import React, { useState } from 'react'
import ChangePasswordEdit from './ChangePasswordEdit';
import ChangePasswordDetails from './ChangePasswordDetails';

function ChangePassword() {
 const [showEdit, setShowEdit] = useState();
 return(
  showEdit ? 
  <ChangePasswordEdit setShowEdit={setShowEdit}/>
  :
  <ChangePasswordDetails setShowEdit={setShowEdit}/>
 )
}

export default ChangePassword